import { useContext } from 'react';
import { ManageUserFormContext, } from '../contexts/manage-user-form-context';
export var useManageUserForm = function () {
    var context = useContext(ManageUserFormContext);
    if (!context) {
        throw new Error('useManageUserForm must be used within a ManageUserFormProvider');
    }
    return context;
};
